import { streamCanvasEdit } from "./canvasEdit";
import { streamChatResponse } from "./chatService";
export * from "./chatSchema";
export * from "./schema";

const ZslCreator = {
  streamCanvasEdit,
  streamChatResponse,
};

export { ZslCreator };
